<script lang="ts">
  import {cn} from 'Catalyst/cn';
  import {type IconProps, fontelloIcons, iconTvProps} from '.';
  import 'material-symbols';

  const DEFAULT_ICON_NAME = 'local_fire_department';

  export let density: IconProps['density'] =
    iconTvProps.defaultVariants.density;
  export let filled: IconProps['filled'] = false;
  export let name: IconProps['name'] = DEFAULT_ICON_NAME;
  export let size: IconProps['size'] = iconTvProps.defaultVariants.size;
  export let style: IconProps['style'] = 'rounded';

  $: iconTvSlots = iconTvProps({density, size});

  $: klass = $$restProps.class;

  $: icon = name || DEFAULT_ICON_NAME;

  // @ts-ignore
  $: isFontello = fontelloIcons.includes(name);
</script>

<span class={cn(iconTvSlots.base(), klass)} data-testid={`${icon}-icon`}>
  <span
    class={cn(
      'select-none',
      isFontello ? `icon-${icon}` : `material-symbols-${style}`,
      iconTvSlots.icon()
    )}
    class:filled
    aria-hidden
  >
    {#if !isFontello}
      {icon}
    {/if}
  </span>
</span>

<style>
  .filled {
    font-variation-settings: 'FILL' 1;
  }
</style>
